import { apiTransformer } from 'utils';

export const trainerToApiTransformer = values => {
    return apiTransformer(values, ['rank', 'qualification', 'profile']);
}
